/*
  Bežiaci text (marquee) – výkonová verzia (Claude, 11/2026).
  Pôvodný skript posúval text v každom snímku (~60× za sekundu) a pri tom stále
  meral šírky prvkov, čo nútilo prehliadač dookola prepočítavať layout stránky.
  Teraz skript raz nakopíruje text a spustí jednu animáciu posunu (Web Animations API,
  transform s pevnými px), ktorú prehliadač vykresľuje mimo hlavného vlákna.
  Prepočíta sa len pri zmene veľkosti okna alebo písma.
  Nastavenia v editore témy (rýchlosť, smer, pauza pri prejdení myšou) fungujú rovnako.
  Rýchlosť = data-scrolling-speed px/s na desktope, /1.5 na mobile (ako pôvodne).
*/
(function () {
	if (typeof customElements === "undefined" || customElements.get("scrolling-text")) return;

	var STYLE_ID = "scrolling-text-css";
	if (!document.getElementById(STYLE_ID)) {
		var style = document.createElement("style");
		style.id = STYLE_ID;
		style.textContent =
			".scrolling-text__track{display:flex;flex:none;white-space:nowrap;will-change:transform}" +
			".scrolling-text__track>*{flex:none}";
		document.head.appendChild(style);
	}

	class ScrollingText extends HTMLElement {
		connectedCallback() {
			if (this._track) return;
			var source = this.firstElementChild;
			if (!source) return;

			var track = document.createElement("div");
			track.className = "scrolling-text__track";
			this.insertBefore(track, source);
			track.appendChild(source);
			this._source = source;
			this._track = track;
			this._offscreen = false;
			this._hover = false;

			var self = this;
			this._schedule = function () {
				cancelAnimationFrame(self._raf);
				self._raf = requestAnimationFrame(function () {
					self._build();
				});
			};

			if ("ResizeObserver" in window) {
				this._resizeObserver = new ResizeObserver(this._schedule);
				this._resizeObserver.observe(this);
				this._resizeObserver.observe(source);
			} else {
				window.addEventListener("resize", this._schedule);
			}

			if ("IntersectionObserver" in window) {
				this._intersectionObserver = new IntersectionObserver(function (entries) {
					self._offscreen = !entries[0].isIntersecting;
					self._updatePlayState();
				});
				this._intersectionObserver.observe(this);
			}

			if (this.dataset.pauseOnHover === "true") {
				this.addEventListener("mouseenter", function () {
					self._hover = true;
					self._updatePlayState();
				});
				this.addEventListener("mouseleave", function () {
					self._hover = false;
					self._updatePlayState();
				});
			}

			this._schedule();
		}

		disconnectedCallback() {
			if (this._resizeObserver) this._resizeObserver.disconnect();
			if (this._intersectionObserver) this._intersectionObserver.disconnect();
			if (this._schedule) window.removeEventListener("resize", this._schedule);
			if (this._animation) this._animation.cancel();
			cancelAnimationFrame(this._raf);
		}

		_updatePlayState() {
			if (!this._animation) return;
			if (this._offscreen || this._hover) {
				if (this._animation.playState === "running") this._animation.pause();
			} else if (this._animation.playState !== "running") {
				this._animation.play();
			}
		}

		_build() {
			var boxWidth = this.clientWidth;
			var itemWidth = this._source.getBoundingClientRect().width;
			if (!boxWidth || !itemWidth) return;

			var isMobile = window.innerWidth <= 768;
			if (boxWidth === this._boxWidth && itemWidth === this._itemWidth && isMobile === this._isMobile) return;
			this._boxWidth = boxWidth;
			this._itemWidth = itemWidth;
			this._isMobile = isMobile;

			// Toľko kópií, aby pás pokryl šírku boxu aj počas posunu o jednu kópiu.
			var needed = Math.ceil(boxWidth / itemWidth) + 1;
			var track = this._track;
			while (track.children.length > needed) track.removeChild(track.lastElementChild);
			while (track.children.length < needed) {
				var copy = this._source.cloneNode(true);
				copy.setAttribute("aria-hidden", "true");
				track.appendChild(copy);
			}

			var baseSpeed = parseInt(this.dataset.scrollingSpeed, 10) || 100;
			var speed = isMobile ? baseSpeed / 1.5 : baseSpeed; // px za sekundu
			var duration = (itemWidth / speed) * 1000;
			var shift = (this.dataset.scrollingDirection === "rtl" ? 1 : -1) * itemWidth;

			// Pri prepočte (zmena veľkosti) pokračovať z rovnakého miesta slučky.
			var progress = 0;
			if (this._animation) {
				var oldDuration = this._animation.effect.getTiming().duration;
				progress = ((this._animation.currentTime || 0) % oldDuration) / oldDuration;
				this._animation.cancel();
			}

			if (typeof track.animate !== "function") return;
			this._animation = track.animate(
				[{ transform: "translate3d(0px,0,0)" }, { transform: "translate3d(" + shift + "px,0,0)" }],
				{ duration: duration, iterations: Infinity, easing: "linear" }
			);
			this._animation.currentTime = progress * duration;
			this._updatePlayState();
		}
	}

	customElements.define("scrolling-text", ScrollingText);
})();
